import { DatabaseModel, DatabaseModelElement } from "./DatabaseModel";
import { TableCell, TableRow } from "@mui/material";
import React from "react";
// @ts-ignore
import { Link } from "react-router";
import { formatDate } from "../utils/formatDate";

export enum OrderStatus {
  PAID = "PAID",
  UNPAID = "UNPAID",
  BOTH = "BOTH",
}

export enum StatusInvoicing {
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
}
export enum Type {
  ORDERS = "ORDERS",
}

export default class SubsSubscriptionAdditional extends DatabaseModel implements DatabaseModelElement {
  static modelName = "SubsSubscriptionAdditional";

  constructor(
    public id: number = 0,
    public subs_subscription_id: number = 0,
    public salesarea_ids: number[] = [],
    public start_date: Date | null = null,
    public unit_price: number | null = 0,
    public type: Type | null = null,
    public order_status: Type | null = null,
    public ignore_dbfields_with: string | null,
    public status_invoicing: StatusInvoicing = StatusInvoicing.ACTIVE,
    public notes: string | null = null,
    public created_at: Date = new Date(),
    public updated_at: Date = new Date(),
    public deleted_at: Date | null = null
  ) {
    super();
  }

  static CreateModel(model: any): SubsSubscriptionAdditional {
    return new SubsSubscriptionAdditional(
      model.id,
      model.subs_subscription_id,
      model.salesarea_ids,
      model.start_date ? new Date(model.start_date) : null,
      model.unit_price,
      model.type,
      model.order_status,
      model.ignore_dbfields_with,
      model.status_invoicing,
      model.notes,
      new Date(model.created_at),
      new Date(model.updated_at),
      model.deleted_at ? new Date(model.deleted_at) : null
    );
  }

  static tableRowHeader() {
    return (
      <TableRow>
        <TableCell>Start Date</TableCell>
      </TableRow>
    );
  }

  tableRow() {
    return (
      <TableRow>
        <TableCell>{this.start_date != null ? formatDate(this.start_date) : "Not started"}</TableCell>
      </TableRow>
    );
  }
}
